/* Moved from sections/hlth-health-formula.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        var sectionId = SID;
        var openBtns = document.querySelectorAll('.hlth-hf-' + sectionId + ' [data-hf-drawer-open]');
        var closeBtn = document.querySelector('[data-hf-drawer-close-' + sectionId + ']');
        var overlay = document.querySelector('[data-hf-drawer-overlay-' + sectionId + ']');
        var drawer = document.querySelector('[data-hf-drawer-' + sectionId + ']');
        var drawerBody = drawer ? drawer.querySelector('.hlth-hf-drawer__body') : null;
        if (!drawer) return;

        var lastFocused = null;

        function openDrawer(targetId) {
          drawer.classList.add('is-open');
          if (overlay) overlay.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          if (targetId && drawerBody) {
            var target = document.getElementById(targetId);
            if (target) {
              drawerBody.querySelectorAll('.hlth-hf-group').forEach(function(el){ el.classList.remove('is-highlighted'); });
              setTimeout(function() {
                drawerBody.scrollTo({ top: target.offsetTop - 12, behavior: 'smooth' });
                target.classList.add('is-highlighted');
              }, 300);
            }
          }
          if (closeBtn) closeBtn.focus();
        }

        function closeDrawer() {
          drawer.classList.remove('is-open');
          if (overlay) overlay.classList.remove('is-open');
          document.body.style.overflow = '';
          if (lastFocused && typeof lastFocused.focus === 'function') {
            lastFocused.focus();
          }
        }

        openBtns.forEach(function(btn) {
          btn.addEventListener('click', function() {
            lastFocused = btn;
            var targetId = btn.getAttribute('data-hf-target');
            if (drawer.classList.contains('is-open') && !targetId) {
              closeDrawer();
            } else {
              openDrawer(targetId);
            }
          });
        });

        if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
        if (overlay) overlay.addEventListener('click', closeDrawer);
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
        });
      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-health-formula')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-health-formula').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_health_formula) return;
      w.__hlthJs_hlth_health_formula = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
